import angular from 'angular';
import uiRouter from 'angular-ui-router';

import ServicesDetailsComponent from './details.component';

const servicesDetailsModule = angular.module('tinaba.components.services.details', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('services.details', {
    url: '/details',
    template: '<services-details></services-details>'
  });
})
.component('servicesDetails', ServicesDetailsComponent);

export default servicesDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/details/details.js
 **/